import {JwtAxios} from "@/packaging";
import dayjs from "dayjs";

export const directDBAPI = {
    async SearchDirectDB(page,limit=15,startDate="",endDate="", directDepth="", keywordType="",keyword="", source="all"){
        if(startDate=="" || endDate =="") {
            startDate='1990-01-01'
            endDate= dayjs().format('YYYY-MM-DD')
        }
        const responseModel = await JwtAxios.get(`/DirectDB/SearchDirectDB?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&directDepth=${directDepth}&keywordType=${keywordType}&keyword=${keyword}&source=${source}`);
        return responseModel
    },

    async GetDirectDBCount(startDate="",endDate="", directDepth="", keywordType="",keyword="", source="all"){
        if(startDate=="" || endDate =="") {
            startDate='1990-01-01'
            endDate= dayjs().format('YYYY-MM-DD')
        }
        const responseModel = await JwtAxios.get(`/DirectDB/GetDirectDBCount?startDate=${startDate}&endDate=${endDate}&directDepth=${directDepth}&keywordType=${keywordType}&keyword=${keyword}&source=${source}`);
        return responseModel
    },

    async GetDirectDBCountByCategory(startDate="",endDate=""){
        if(startDate=="" || endDate =="") {
            startDate='1990-01-01'
            endDate= dayjs().format('YYYY-MM-DD')
        }
        const responseModel = await JwtAxios.get(`/DirectDB/GetDirectDBCountByCategory?startDate=${startDate}&endDate=${endDate}`);
        return responseModel
    },

    async GetDirectDBTotalCount(directDepth){
        const responseModel = await JwtAxios.get(`/DirectDB/GetDirectDBTotalCount?directDepth=${directDepth}`);
        return responseModel
    },

    async GetDirectDepthCategories(){
        const responseModel = await JwtAxios.get(`/DirectDB/GetDirectDepthCategories`);
        return responseModel
    },

    async GetDirectDBByCategory(page,limit=15,startDate="",endDate="", directDepth="", source="all"){
        if(startDate=="" || endDate =="") {
            startDate='1990-01-01'
            endDate= dayjs().format('YYYY-MM-DD')
        }
        const responseModel = await JwtAxios.get(`/DirectDB/GetDirectDBByCategory?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&directDepth=${directDepth}&source=${source}`);
        return responseModel
    },

    async ExportExcel(model){
        const responseModel = await JwtAxios.download(`/DirectDB/ExportExcel`,model);
        return responseModel
    },
}